import moment from 'moment';
import _ from 'lodash';
import axios from 'axios';

export default {
  init({ state, dispatch }, payload) {
    state.vueInstance = payload.vueInstance;
    dispatch('setupDefaultDates');

    /* If we already have a default activity id, we don't need to get all the activity groups */
    if (!window.activity_id) {
      state.activities.initialLoad = false;
      dispatch('getActivityGroups');
    }

    /* Check if there's a query parameter set for the activity id */
    var uri = window.location.search.substring(1);
    var params = new URLSearchParams(uri);
    if (params.get('activity_id')) {
      window.activity_id = params.get('activity_id');
      dispatch('toggleBodyClass');
      state.ui.modalState = 3;
    }

    dispatch('getActivities');

    dispatch('getCustomTreatmentDurations');

    dispatch('maybeLoadBookingFromOrderRef');
  },

  /* 
    When the booking module is first loaded, check if a query parameter for "orderref" exists. 
    If it does, load the order with the order ref and start polling it for a BankID response. 
    This is done because the BankID app sometimes redirects the user to a new browser or new tab after the user has signed with BankID, 
    and in those scenarios we need to load the order from using the OrderRef since we can't access the state of the users booking.
    */
  maybeLoadBookingFromOrderRef({ state, dispatch }) {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    var orderref = params.get('orderref');
    if (!orderref) {
      return;
    }
    /* If there's an order ref, set it up and start fetching the BankID response. */
    state.booking.orderRef = orderref;
    state.booking.backupOrderRef = orderref;
    /* Set up loading... */
    state.ui.loading.doingBooking = true;
    state.orderRefQueryParameterLoaded = true;
    /* Set a timeout here to make all variables work correctly */
    window.setTimeout(() => {
      dispatch('collectBankIDResponseAndSendBooking');
    }, 1000);
  },

  setupDefaultDates({ state, dispatch }, getAvailableTimes) {
    /* If we're on a Sunday, set the current date to Monday next week */
    let date = moment();
    /*
        if (moment().format('e') == '6') {
          date.add(1, 'd');
        }
        */
    state.firstLoadForActivity = true;
    dispatch('setupActiveDateFromDate', {
      date: date.format('YYYY-MM-DD'),
    }).then(() => {
      /* Clone todays date and set it to the active date */
      state.dates.current = Object.assign({}, state.dates.active);

      /* Set the last future date that we will fetch bookings for. By default, we set this to 6 months */
      state.dates.current.checkBookingsToDate = moment()
        .add(1, 'months')
        .endOf('isoWeek')
        .format('YYYY-MM-DD');

      if (getAvailableTimes) {
        var payload = {
          dontNavigateToNextAvailableTime: true, // Don't trigger navigation to the next available time because it causes the user to be thrown back into the calendar.
        };
        dispatch('getAvailableTimes', payload);
      }
    });
  },
  setupWeekdaysForWeek({ state, dispatch }, weekNumber) {
    dispatch('setupDatesForMonth');
    var weekdays = [
      'Måndag',
      'Tisdag',
      'Onsdag',
      'Torsdag',
      'Fredag',
      'Lördag',
      'Söndag',
    ];
    state.dates.active.weekdays = [];
    for (var i in weekdays) {
      var data = {
        date: moment()
          .isoWeekYear(state.dates.active.year)
          .week(weekNumber)
          .isoWeekday(weekdays[i]),
        name: moment()
          .isoWeekYear(state.dates.active.year)
          .week(weekNumber)
          .isoWeekday(weekdays[i])
          .format('ddd'),
        longName: moment()
          .isoWeekYear(state.dates.active.year)
          .week(weekNumber)
          .isoWeekday(weekdays[i])
          .format('dddd'),
        dayOfMonth: moment()
          .isoWeekYear(state.dates.active.year)
          .week(weekNumber)
          .isoWeekday(weekdays[i])
          .format('D'),
        niceDate: moment()
          .isoWeekYear(state.dates.active.year)
          .week(weekNumber)
          .isoWeekday(weekdays[i])
          .format('YYYY-MM-DD'),
        monthShortName: moment()
          .isoWeekYear(state.dates.active.year)
          .week(weekNumber)
          .isoWeekday(weekdays[i])
          .format('MMM'),
        monthLongName: moment()
          .isoWeekYear(state.dates.active.year)
          .week(weekNumber)
          .isoWeekday(weekdays[i])
          .format('MMMM'),
        availableTimes: [],
        activeTimes: [],
      };
      state.dates.active.weekdays.push(data);
    }
    dispatch('fillOutCalendarWithAvailableTimes');
  },
  setupDatesForMonth({ state, dispatch }) {
    /*
        Get all the dates that should be displayed in the calendar.
        I.e. even if the month starts on the 1st of March, we might want to display a few days before or after
        in order to present a full and coherent calendar
        */
    let firstDayOfMonth = moment(state.dates.active.date.format('YYYY-MM-01'));
    let lastDayOfMonth = moment(
      state.dates.active.date.format('YYYY-MM-') +
      state.dates.active.date.daysInMonth()
    );

    /* 2020-10-15: Trying to set up datesInMonth a different way since the old way caused some issues when viewing January 2020 in month view */

    /*
        let datesInMonth = [];
        for (let weekNumber = firstDayOfMonth.isoWeek(); weekNumber <= lastDayOfMonth.isoWeek(); weekNumber++) {
          for (let dayOfWeek = 1; dayOfWeek <= 7; dayOfWeek++) {
            let date = moment()
              .isoWeekYear(state.dates.active.year)
              .week(weekNumber)
              .isoWeekday(dayOfWeek)
              .format('YYYY-MM-DD');
            datesInMonth.push(date);
          }
        }
        */

    /* We'll fill this empty array with all the dates for this month */
    let datesInMonth = [];

    /* Add dates from previous month to the start of the calendar so that the calendar is nice and even if the new month doesn't start on a Monday */
    let datesToAddToStartOfMonth = firstDayOfMonth.isoWeekday();
    if (datesToAddToStartOfMonth) {
      let dates = []; // We'll flip this array later to make the dates appear in the correct order */
      for (i = 1; i < datesToAddToStartOfMonth; i++) {
        let date = firstDayOfMonth.clone().subtract(i, 'days');
        dates.push(date.format('YYYY-MM-DD'));
      }
      /* Flipping the dates array to make the dates appear in the correct order */
      dates.reverse();
      for (let i in dates) {
        datesInMonth.push(dates[i]);
      }
    }

    /* Set up the rest of the days in the month */
    var currentMonth = moment(state.dates.active.date).month() + 1;
    var currentYear = moment(state.dates.active.date).year();
    var numberOfDays = moment(state.dates.active.date).daysInMonth();
    for (var i = 1; i <= numberOfDays; i++) {
      if (i < 10) {
        i = '0' + i.toString();
      }
      let formatedMonth = currentMonth;
      if (currentMonth < 10) {
        formatedMonth = '0' + currentMonth.toString();
      }
      var dateString = currentYear + '-' + formatedMonth + '-' + i;
      datesInMonth.push(moment(dateString));
    }

    /* Add dates from upcoming month to the end of the calendar so that the calendar is nice and even if the new month doesn't end on a Sunday */
    let datesToAddToEndOfMonth = 7 - lastDayOfMonth.isoWeekday();
    if (datesToAddToEndOfMonth) {
      for (i = 1; i <= datesToAddToEndOfMonth; i++) {
        let date = lastDayOfMonth.clone().add(i, 'days');
        datesInMonth.push(date);
      }
    }

    state.dates.active.monthDates = [];

    /* Loop over all dates in the month */
    for (let i in datesInMonth) {
      let date = moment(datesInMonth[i]);
      var data = {
        date: date,
        niceDate: date.format('YYYY-MM-DD'),
        dayOfWeek: date.isoWeekday(),
        dayOfMonth: date.date(),
        weekOfYear: date.isoWeek(),
        availableTimes: [],
        activeTimes: [],
      };
      state.dates.active.monthDates.push(data);
    }
  },
  fillOutCalendarWithAvailableTimes({ state, dispatch }) {
    if (!state.availableTimes.length) {
      //return;
    }

    /* Order available times by time */
    state.availableTimes = _.sortBy(state.availableTimes, (o) => o.timestamp);

    dispatch('fillOutDates');
  },
  fillOutDates({ state }) {
    return new Promise(
      (resolve) => {
        /* Set up available times */
        let locationIds = [];
        for (var i in state.dates.active.weekdays) {
          var weekday = state.dates.active.weekdays[i];
          weekday.availableTimes = [];
          weekday.activeTimes = [];
          for (var x in state.availableTimes) {
            var time = {
              ...state.availableTimes[x],
              location_name:
                state.availableTimes[x].location_id == 1
                  ? 'Drottninggatan 33'
                  : 'Tegnérgatan 1',
              location_short_name:
                state.availableTimes[x].location_id == 1
                  ? 'Drottninggatan'
                  : 'Tegnérgatan',
            };
            locationIds.push(time.location_id);
            if (time.date == weekday.niceDate) {
              //if (time.terapeut_id == 8 || time.terapeut_id == 12) {
              /*
                            if (time.terapeut_id == 12) {
                              continue;
                            }
                            */

              if (!state.locations.selected) {
                // weekday.availableTimes.push(time);
              }

              /* If we should display times for all providers, push the time slot into the activeTimes array */
              // if (!state.providers.selected && !state.locations.selected) {
              weekday.activeTimes.push(time);
              // }

              /* If we should NOT display times for all providers, push the time slot into the activeTimes array only if the provider name matches the filtered name*/
              // if (
              //   state.providers.selected &&
              //   time.terapeut_sign == state.providers.selected
              // ) {
              //   // console.log('ADD:X ', time.location_id);
              //   weekday.activeTimes.push(time);
              // }
              // if (state.locations.selected && time.location_id == state.locations.selected.id) {
              //   // console.log('ADD:D ', time.location_id);
              //   weekday.activeTimes.push(time);
              // }
            }
          }
          state.dates.active.weekdays[i].availableTimes =
            weekday.availableTimes;
          if (state.providers.selected && state.locations.selected) {
            state.dates.active.weekdays[i].activeTimes =
              weekday.activeTimes.filter(
                (x) =>
                  x.location_id == state.locations.selected.id &&
                  x.terapeut_sign == state.providers.selected
              );
          } else if (state.providers.selected && !state.locations.selected) {
            state.dates.active.weekdays[i].activeTimes =
              weekday.activeTimes.filter(
                (x) => x.terapeut_sign == state.providers.selected
              );
          } else if (!state.providers.selected && state.locations.selected) {
            state.dates.active.weekdays[i].activeTimes =
              weekday.activeTimes.filter(
                (x) => x.location_id == state.locations.selected.id
              );
          } else {
            state.dates.active.weekdays[i].activeTimes = weekday.activeTimes;
          }
        }
        for (let i in state.dates.active.monthDates) {
          let monthDate = state.dates.active.monthDates[i];
          monthDate.availableTimes = [];
          monthDate.activeTimes = [];
          for (var x in state.availableTimes) {
            var time = state.availableTimes[x];

            if (time.date == monthDate.niceDate) {
              //if (time.terapeut_id == 8 || time.terapeut_id == 12) {
              /*
                            if (time.terapeut_id == 12) {
                              continue;
                            }
                            */

              monthDate.availableTimes.push(time);

              /* If we should display times for all providers, push the time slot into the activeTimes array */
              if (!state.providers.selected) {
                monthDate.activeTimes.push(time);
              }

              /* If we should NOT display times for all providers, push the time slot into the activeTimes array only if the provider name matches the filtered name*/
              if (
                state.providers.selected &&
                time.terapeut_sign == state.providers.selected &&
                !state.locations.selected
              ) {
                monthDate.activeTimes.push(time);
              }
              if (
                state.locations.selected &&
                time.location_id == state.locations.selected.id
              ) {
                monthDate.activeTimes.push(time);
              }
            }
          }
          state.dates.active.monthDates[i].availableTimes =
            monthDate.availableTimes;
          state.dates.active.monthDates[i].activeTimes = monthDate.activeTimes;
        }
        resolve();
      },
      (reject) => {
        reject();
      }
    );
  },
  navigateToNextAvailableTime({ state, dispatch }) {
    /*
        If we're on the week view, check if there are any available times for the current week.
        If not, navigate to the next week with available times.
        */
    if (state.ui.calendarViewType != 'week') {
      //return;
    }
    let firstDayNextWeek = moment(state.dates.active.weekEndDate).add(
      1,
      'days'
    );
    /*
        for (let i in state.availableTimes) {
          let availableTime = state.availableTimes[i];
          Check if Monday next week is AFTER the time slot time.
          If it is, don't continue this function and don't navigate the user in the calendar.
          if (firstDayNextWeek.isAfter(availableTime.date)) {
            return;
          }
        }
         */
    if (state.availableTimes.length > 0) {
      console.log(7);
      /* If no provider is selected, navigate to the first available time */
      if (!state.providers.selected) {
        dispatch('setupActiveDateFromDate', {
          date: state.availableTimes[0].date,
        });
        return;
      }
      console.log(8);
      /* If a provider is selected, navigate to the first time for that provider */
      for (let i in state.availableTimes) {
        let availableTime = state.availableTimes[i];
        if (availableTime.terapeut_sign == state.providers.selected) {
          dispatch('setupActiveDateFromDate', { date: availableTime.date });
          return;
        }
      }
    }
  },
  getActivities({ state, dispatch }) {
    axios.get('/wp-json/nk/cb/getActivitiesFromDB/').then((response) => {
      state.activities.available = [];
      var activities = response.data.data.rows.row;
      for (var i in activities) {
        /* Skip activities with a blank name */
        if (activities[i].activity_name.length == 0) {
          continue;
        }

        state.activities.available.push(activities[i]);

        /* This activity should be displayed, which means we should push the activity group id to an array to keep track of which to show. We can then show/hide the correct acitivty groups, and hide those without any visible activities in them. */

        if (
          activities[i].activity_active == '1' &&
          activities[i].activity_hide_in_patient_portal != '1'
        ) {
          if (
            state.activityGroups.withActivities.indexOf(
              activities[i].activity_group_id
            ) === -1
          ) {
            state.activityGroups.withActivities.push(
              activities[i].activity_group_id
            );
          }
        }

        if (window.activity_id) {
          if (activities[i].activity_id == window.activity_id) {
            /* Set up the activity group ID from the window variable */
            var activityGroupId = activities[i].activity_group_id;
            var activityGroup = _.find(
              state.activityGroups.available,
              function (o) {
                return o.activity_group_id === activityGroupId;
              }
            );
            if (activityGroup) {
              dispatch('setActivityGroup', activityGroup);
            }

            dispatch('setActivity', activities[i]);
          }
        }
      }

      state.activities.available = _.sortBy(state.activities.available, (o) =>
        parseInt(o.activity_order, 10)
      );

      if (state.initialLoad == false) {
        dispatch('setupActivities');
      }
      state.activities.loaded = true;
      dispatch('hideEmptyActivityGroups');
    });
  },
  getActivityGroups({ state }) {
    axios.get('/wp-json/nk/cb/getActivityGroupsFromDB/').then((response) => {
      state.activityGroups.available = [];
      var activityGroups = response.data.data.rows.row;
      for (var i in activityGroups) {
        state.activityGroups.available.push(activityGroups[i]);
      }
      state.activityGroups.loaded = true;
    });
  },
  hideEmptyActivityGroups({ state, dispatch }) {
    if (!state.activityGroups.loaded && !state.activities.loaded) {
      window.setTimeout(() => {
        dispatch('hideEmptyActivityGroups');
      }, 100);
      return;
    }

    for (var i in state.activityGroups.available) {
      var activityGroupId = state.activityGroups.available[i].activity_group_id;
      if (_.includes(state.activityGroups.withActivities, activityGroupId)) {
        state.activityGroups.bookable.push(state.activityGroups.available[i]);
      }
    }

    state.activityGroups.bookable = _.sortBy(
      state.activityGroups.bookable,
      (o) => parseInt(o.activity_group_order, 10)
    );

    /* If we coulnd't find any bookable activityGroups, try this again in 1 second */
    if (state.activityGroups.bookable.length == 0) {
      window.setTimeout(() => {
        dispatch('hideEmptyActivityGroups');
      }, 100);
    }
  },
  setActivityGroup({ state, dispatch, getters }, activityGroup) {
    /* Don't allow the user to set this if we're loading times since it'll mess up the UI */
    if (getters.loading.times) {
      // return;
    }

    /* Don't allow a new slot to be set if the user is currently doing a booking, i.e. a BankID sign */
    if (state.ui.loading.doingBooking) {
      return;
    }

    if (state.activityGroups.selected == activityGroup) {
      state.activityGroups.selected = false;
      return;
    }
    state.activityGroups.selected = activityGroup;
    dispatch('setupActivities');
  },
  /* When a user selects an activity from the search results on the booking page via BookingModuleSearchActivity, set the activity group to false to make it a bit more intuitive for the user. */
  setActivityGroupFromSearchResult({ state, dispatch }, activityGroup) {
    //state.activityGroups.selected = activityGroup;
    state.activityGroups.selected = false;
  },
  toggleActivityGroup({ state, dispatch, getters }, activityGroup) {
    /* Don't allow the user to set this if we're loading times since it'll mess up the UI */
    if (getters.loading.times) {
      // return;
    }
    state.activities.selected = false;
    if (state.activityGroups.selected == activityGroup) {
      state.activityGroups.selected = false;
      return;
    }
    dispatch('setActivityGroup', activityGroup);
  },
  setupActivities({ state }) {
    /* If we're running this function for the first time and we already have an activity_id parameter set, we don't want to reset that by setting state.activities.selected = false, so we just return this time */
    if (state.activities.initialLoad == false) {
      state.activities.selected = false;
    }

    state.activities.active = [];

    var activityGroup = state.activityGroups.selected;

    /* Loop through all activities and discard whichever are not active and do not match the selected activity group */
    for (var i in state.activities.available) {
      var activity = state.activities.available[i];
      if (activity.activity_active != '1') {
        continue;
      }
      if (activity.activity_hide_in_patient_portal == '1') {
        continue;
      }
      if (activity.activity_group_id == activityGroup.activity_group_id) {
        state.activities.active.push(activity);
      }
    }
  },
  setActivity({ state, dispatch }, activity) {
    /* Don't let the user set the activity if we're loading times because this messes up the UI and can make times for a certain provider appear under the wrong headline in the calendar */
    if (state.ui.loading.times) {
      // return;
    }

    /*
        Set this to true so that we fetch more times the first time an activity is selected.
        Then, when the user navigates the calendar with the arrows, only load the necessary number of times on each navigation.
        */
    state.firstLoadForActivity = true;
    dispatch('setupActiveDateFromDate', {
      date: state.dates.current.niceDate,
    })
      .then(() => {
        state.providers.available = false;
        state.locations.available = false;
        state.ui.selectingProvider = false;
        state.ui.selectingLocation = false;
        dispatch('setProvider', false);
        dispatch('setLocation', false);

        state.selectedSlot = false;
        state.activities.selected = activity;

        dispatch('getAvailableTimes', {
          activityJustSet: true,
        });

        if (document.getElementById('book-time-dates')) {
          window.setTimeout(() => {
            state.vueInstance.$SmoothScroll(
              document.getElementById('book-time-dates'),
              500
            );
          }, 100);
        }

        dispatch('getProviders');
        dispatch('getLocations'); // Maybe
      })
      .catch(() => { });
  },
  setProvider({ state, dispatch, getters }, provider) {
    console.log('state.providers.selected', state.providers.selected, provider);
    state.providers.selected = provider;
    state.ui.selectingProvider = false;
    /* Navigate to the next available time if there are no available times with this provider for the week the user is looking at currently */
    dispatch('fillOutDates')
      .then(() => {
        /* Check if there are not any available times for the current week. If so, navigate to the next available time */
        if (getters.noAvailableTimesForWeek) {
          dispatch('navigateToNextAvailableTime');
        }
      })
      .catch(() => { });
  },
  setLocation({ state, dispatch, getters }, location) {
    console.log('state.locations.selected', state.locations.selected, location);
    if (state.locations.selected.id == location.id) {
      state.locations.selected = false;
    } else {
      state.locations.selected = location;
    }
    state.ui.selectingLocation = false;
    dispatch('fillOutDates')
      .then(() => {
        /* Check if there are not any available times for the current week. If so, navigate to the next available time */
        if (getters.noAvailableTimesForWeek) {
          dispatch('navigateToNextAvailableTime');
        }
      })
      .catch(() => { });
  },
  getNextAvailableTime({ state, dispatch }) {
    if (!state.activities.selected.activity_id) {
      return;
    }
    state.ui.loading.times = true;

    axios
      .get('/wp-json/nk/cb/getNextAvailableTime/', {
        params: {
          activity_id: state.activities.selected.activity_id,
        },
      })
      .then((response) => {
        if (response.data.data.rows == undefined) {
          state.availableTimes = [];
          state.ui.loading.times = false;
          return;
        }
        let nextAvailableTime = response.data.data.rows.row;
        let payload = {
          date: nextAvailableTime.date,
        };
        dispatch('setupActiveDateFromDate', payload);

        state.ui.loading.times = false;
      });
  },
  setupActiveDateFromDate({ state, dispatch }, payload) {
    return new Promise((resolve) => {
      let date = moment(payload.date);
      if (state.ui.calendarViewType == 'month') {
        date = date.startOf('month');
      }
      let activeDateObject = {
        date: date,
        day: date.date(),
        week: date.week(),
        month: date.month(),
        year: date.isoWeekYear(),
        niceDate: date.format('YYYY-MM-DD'),
        monthName: date.format('MMMM'),
        monthShortName: date.format('MMM'),
        monthLongName: date.format('MMMM'),
        weekStartDate: date.startOf('isoWeek').format('YYYY-MM-DD'),
        weekEndDate: date.endOf('isoWeek').format('YYYY-MM-DD'),
        slots: [],
        checkBookingsFromDate: date.startOf('isoWeek').format('YYYY-MM-DD'),
        checkBookingsToDate: date.endOf('isoWeek').format('YYYY-MM-DD'),
        previousWeek: date.clone().subtract(1, 'w').week(),
        nextWeek: date.clone().add(1, 'w').week(),
        previousMonth: date.clone().subtract(1, 'months').format('MMMM'),
        previousMonthShortName: date
          .clone()
          .subtract(1, 'months')
          .format('MMM'),
        nextMonth: date.clone().add(1, 'months').format('MMMM'),
        nextMonthShortName: date.clone().add(1, 'months').format('MMM'),
        monthDates: [],
      };

      /* If we're set to display weeks or if we're NOT on a single treatment page, check bookings for one week ahead or if this is NOT the first load for this activity */
      if (
        state.ui.calendarViewType == 'week' &&
        !window.singleTreatmentPage &&
        !state.firstLoadForActivity
      ) {
        activeDateObject.checkBookingsToDate = date
          .clone()
          .endOf('isoWeek')
          .format('YYYY-MM-DD');
        /* Else check bookings for one month ahead, and also one week before and after the month, to fill out the calendar correctly */
      } else {
        activeDateObject.checkBookingsFromDate = date
          .clone()
          .startOf('month')
          .subtract(1, 'w')
          .format('YYYY-MM-DD');
        activeDateObject.checkBookingsToDate = date
          .clone()
          .endOf('isoWeek')
          .format('YYYY-MM-DD');
      }
      state.firstLoadForActivity = false;
      console.log(9);
      state.dates.active = activeDateObject;
      dispatch('setupWeekdaysForWeek', activeDateObject.week);
      resolve();
    });
  },
  getAvailableTimes({ state, dispatch }, payload) {
    if (!state.activities.selected.activity_id) {
      return;
    }

    console.log(1);

    /* Hide the showGetNextAvailableTimeButton */
    state.ui.showGetNextAvailableTimeButton = false;
    /* If we should increase the checkBookingsToDate, do it */
    if (payload) {
      console.log(2);
      if (payload.increasedCheckBookingsToDate) {
        /*
        Set the Check Bookings From Date to the 'checkBookingsToDate' variable, since ClinicBuddy only lets us 
        fetch available times like 3 months ahead of time
        */
        state.dates.active.checkBookingsFromDate = moment(
          state.dates.active.checkBookingsToDate
        ).format('YYYY-MM-DD');

        state.dates.active.checkBookingsToDate = moment(
          state.dates.active.checkBookingsToDate
        )
          .add(3, 'M')
          .format('YYYY-MM-DD');
      }
    }

    state.ui.loading.times = true;

    console.log(3);
    /* Keep track on if we should navigate to the next available time. The default behaviour is 'true' */
    var doNavigateToNextAvailableTime = true;
    if (payload) {
      if (payload.dontNavigateToNextAvailableTime) {
        doNavigateToNextAvailableTime = false;
      }
    }

    /* Check if available times are loaded. If so, don't make a request to the API */
    dispatch('availableTimesAreLoaded')
      .then((response) => {
        console.log(4);
        /* Available times are loaded */
        state.ui.loading.times = false;
        /*
        If the user has just set a new activity, i.e. clicked an activity button to fetch times,
        navigate to the next available time
        */
        if (
          payload &&
          payload.activityJustSet &&
          doNavigateToNextAvailableTime
        ) {
          console.log(5);
          dispatch('navigateToNextAvailableTime');
        }
        dispatch('formatLocations');
        return;
      })
      .catch(() => {
        console.log(6);
        if (state.ui.loading.signal) {
          state.ui.loading.signal.cancel();
        }
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        state.ui.loading.signal = source;
        /* Available times are NOT loaded */
        let postData = {
          activity_id: state.activities.selected.activity_id,
          date_from:
            moment() >= moment(state.dates.active.checkBookingsFromDate)
              ? moment().format('YYYY-MM-DD')
              : state.dates.active.checkBookingsFromDate,
          date_to: state.dates.active.checkBookingsToDate,
        };
        axios
          .post('/wp-json/nk/cb/getAvailableTimes/', postData, {
            cancelToken: source.token,
          })
          .then((response) => {
            if (response.data.data.rows == undefined) {
              state.availableTimes = [];
              state.ui.loading.times = false;

              /*
                            If there are no available times, 
                            set showGetNextAvailableTimeButton to true to allow the user to 
                            do a search for available times where the checkBookingsToDate 
                            is set further ahead in the future
                            */
              if (!state.availableTimes.length) {
                state.ui.showGetNextAvailableTimeButton = true;
              }

              /* Store an empty array as the available times */
              dispatch('storeAvailableTimes', []);
              /* Set up the available times to make the calendar blank */
              dispatch('setupAvailableTimes');
              return;
            }

            state.availableTimes = [];

            /* If we only received a single time from the ClinicBuddy API, it will be delivered as an object instead of as an array.
                        If so, convert it to an array containing the time slot object so that we can handle it correctly. */
            if (!Array.isArray(response.data.data.rows.row)) {
              response.data.data.rows.row = [response.data.data.rows.row];
            }

            if (window.singleTreatmentPage) {
              /* If we're on the single treatment page, filter the available times so that we don't get one with the wrong tereapeut id, e.g. for terapeuts that should be hidden */
              _.forEach(response.data.data.rows.row, (time, key) => {
                //if (time.terapeut_id == 8 || time.terapeut_id == 12) {
                /*
                                if (time.terapeut_id == 12) {
                                  return true;
                                }
                                */
                state.availableTimes.push(time);
              });
            } else {
              let times = [];
              for (let i in response.data.data.rows.row) {
                let time = response.data.data.rows.row[i];
                //if (time.terapeut_id == 8 || time.terapeut_id == 12) {
                /*
                                if (time.terapeut_id == 12) {
                                  continue;
                                }
                                */
                times.push(time);
              }
              state.availableTimes = times.map((time) => ({
                ...time,
                location_name:
                  time.location_id == 1 ? 'Drottninggatan 33' : 'Tegnérgatan 1',
                location_short_name:
                  time.location_id == 1 ? 'Drottninggatan' : 'Tegnérgatan',
              }));
              console.log(
                'state.availableTimesstate.availableTimes',
                state.availableTimes
              );
              console.log('STATE CHECK: ', state);
              dispatch('storeAvailableTimes', times);
              dispatch('setupAvailableTimes');
            }

            /* Check if available times is an object with only one time (eg the length is 'undefined'). If so, we need to convert it into an array */
            if (state.availableTimes.length == undefined) {
              console.log('ARE WE IN HERE?');
              var clonedAvailableTimes = Object.assign(
                {},
                state.availableTimes
              );
              state.availableTimes = [];
              state.availableTimes.push(clonedAvailableTimes);
              console.log(
                'AVAILABLETIMESSSS clonedAvailableTimes',
                clonedAvailableTimes
              );
            }

            dispatch('setupAvailableTimes');
            if (doNavigateToNextAvailableTime) {
              dispatch('navigateToNextAvailableTime');
            }
          });
      });
  },
  setupAvailableTimes({ state, dispatch }) {
    /* Set up available times */
    dispatch('fillOutCalendarWithAvailableTimes');
    state.ui.loading.times = false;
    state.activities.initialLoad = false;
    state.locations.selected = false;
    dispatch('getLocations');
  },
  getProviders({ state, dispatch }) {
    axios
      .get('/wp-json/nk/cb/getProvidersByActivity', {
        params: {
          activity_id: state.activities.selected.activity_id,
        },
      })
      .then((response) => {
        state.providers.available = response.data.data;
        dispatch('reorderProviders');
      })
      .catch(() => { });
  },
  formatLocations({ state, dispatch }) {
    let temp = state.availableTimes.map((time) => ({
      ...time,
      location_name:
        time.location_id == 1 ? 'Drottninggatan 33' : 'Tegnérgatan 1',
      location_short_name:
        time.location_id == 1 ? 'Drottninggatan' : 'Tegnérgatan',
    }));
    state.availableTimes = temp;
    console.log('state.availableTimesstate.availableTimes!!!', temp);
    dispatch('storeAvailableTimes', temp);
  },
  getLocations({ state, dispatch }) {
    let temp = [];
    if (state.availableTimes && state.availableTimes.length > 0) {
      temp = state.availableTimes
        .map((item) => {
          if (item.location_id) {
            return {
              id: item.location_id,
              name:
                item.location_id == '1' ? 'Drottninggatan 33' : 'Tegnérgatan 1',
              short_name:
                item.location_id == '1' ? 'Drottninggatan' : 'Tegnérgatan',
            };
          }
          return null;
        })
        .filter((x) => !!x);
      temp = temp.reduce((unique, o) => {
        if (!unique.some((obj) => obj.id === o.id)) {
          unique.push(o);
        }
        return unique;
      }, []);
      console.log('TEMP', temp);
      state.locations.available = temp.sort((a, b) => a.id - b.id);
      // dispatch('fillOutDates');
      // dispatch('fillOutCalendarWithAvailableTimes');
    } else {
      state.locations.available = [];
    }
  },
  reorderProviders({ state }) {
    /* Define an array of the providers I want to move. This should be defined backwards, so that the last person in the array is the one that will be first when the function is done running */
    var elementsToMove = [
      'Malin Brinde Aukt. Hudterapeut',
      'Emma Kansell Aukt. Hudterapeut',
      'Carolina Ryberg Aukt. Hudterapeut',
      'Alexandra Lindbergh Aukt. Hudterapeut',
      'Denise Fa Injektionssjuksköterska',
      'Danielle Fa Injektionssjuksköterska',
      'Hamid Natghian Leg. Läkare. Specialist i plastikkirurgi',
      'Pehr Sommar Leg. Läkare Specialist i plastikkirurgi',
      'Said Saidian Leg. Läkare Specialist i plastikkirurgi',
      'Marcus Ehrström Leg. Läkare. Specialist i plastikkirurgi',
      'Magnus Kjelsberg Leg. Läkare. Specialist i plastikkirurgi',
      'Mattias Elmér Leg. Läkare. Specialist i plastikkirurgi',
      'Patrik Höijer Leg. Läkare. Specialist i plastikkirurgi',
    ];

    for (var i in elementsToMove) {
      var element = elementsToMove[i];
      if (state.providers.available.indexOf(element) > 0) {
        state.providers.available.splice(
          state.providers.available.indexOf(element),
          1
        );
        state.providers.available.unshift(element);
      }
    }
  },
  setupActiveDates({ state, dispatch }, direction) {
    if (state.ui.loading.times == true) {
      return;
    }

    if (direction == 'reset') {
      dispatch('setupDefaultDates', true);
      return;
    }

    if (document.getElementById('book-time-dates')) {
      window.setTimeout(() => {
        state.vueInstance.$SmoothScroll(
          document.getElementById('book-time-dates'),
          500
        );
      }, 100);
    }

    /* Get the type of calendar that the user is vieweing to subtract and add weeks or months */
    let type = 'w';
    if (state.ui.calendarViewType == 'month') {
      type = 'months';
    }

    if (direction == 'back') {
      state.dates.active.date = state.dates.active.date.subtract(1, type);
    }

    if (direction == 'forward') {
      state.dates.active.date = state.dates.active.date.add(1, type);
    }

    dispatch('setupActiveDateFromDate', {
      date: state.dates.active.date.format('YYYY-MM-DD'),
    }).then(() => {
      var payload = {
        dontNavigateToNextAvailableTime: true, // Don't trigger navigation to the next available time because it causes the user to be thrown back into the calendar.
      };
      dispatch('getAvailableTimes', payload);
    });
  },
  setSelectedSlot({ state, dispatch }, slot) {
    /* Don't allow a new slot to be set if the user is currently doing a booking, i.e. a BankID sign */
    if (state.ui.loading.doingBooking) {
      return;
    }

    /* Clear the booking message when a slot is selected so that we don't display a potential old booking error message when the user selects a new slot */
    state.booking.message = false;

    dispatch('removeBodyClass');
    state.selectedSlot = slot;

    if (slot.location_id == 1) {
      state.selectedSlot.location_name = 'Drottninggatan 33';
      state.selectedSlot.location_short_name = 'Drottninggatan';
    } else {
      state.selectedSlot.location_name = 'Tegnérgatan 1';
      state.selectedSlot.location_short_name = 'Tegnérgatan';
    }

    if (slot == false) {
      return;
    }

    /* Focus on the first input field in the booking module so that the user can enter its name IF we're not on Internet Explorer */
    if (!document.body.classList.contains('ms-ie')) {
      window.setTimeout(() => {
        if (document.getElementById('patient-firstname')) {
          document.getElementById('patient-firstname').focus();
        }
      }, 650);
    }

    if (document.getElementById('book-time-form-anchor')) {
      window.setTimeout(() => {
        state.vueInstance.$SmoothScroll(
          document.getElementById('book-time-form-anchor'),
          500
        );
      }, 100);
    }

    if (
      document.getElementById('book-time-activity-form') &&
      !state.ui.didSwipe
    ) {
      window.setTimeout(() => {
        state.vueInstance.$SmoothScroll(
          document.getElementById('book-time-activity-form'),
          500
        );
      }, 100);
    }
  },
  toggleBodyClass() {
    var body = document.getElementsByTagName('BODY')[0];
    body.classList.toggle('mobile-menu-toggled');
  },

  removeBodyClass() {
    var body = document.getElementsByTagName('BODY')[0];
    body.classList.remove('mobile-menu-toggled');
  },

  addBodyClass() {
    var body = document.getElementsByTagName('BODY')[0];
    body.classList.add('mobile-menu-toggled');
  },
  setModalState({ state, dispatch }, value) {
    /* Set the modal state. If the value is 0, the modal should not be shown and we'll remove the body class. If it is above 1, we'll add the body class */

    if (value > 0) {
      dispatch('addBodyClass');
      state.ui.modalState = value;
    } else {
      dispatch('removeBodyClass');
      state.ui.modalState = 0;
    }
  },
  handleSwipe({ state }, event) {
    //event.preventDefault();
    /* Set didSwipe to true, then reset to false after 100 ms. This is a workaround to distinguish swipes and clicks in the slick slider when doing bookings on a single treatment page, like "Bröstförstoring" */
    state.ui.didSwipe = true;
    window.setTimeout(() => {
      state.ui.didSwipe = false;
    }, 100);
  },
  /* Prepare new booking when one has already been made */
  prepareNewBooking({ state, dispatch }) {
    state.booking.message = false;
    state.booking.timeStart = false;
    state.booking.timeEnd = false;
    state.booking.activityName = false;
    state.booking.completed = false;
    state.selectedSlot = false;
    dispatch('setModalState', false);
    state.loadedTimes = [];
    state.booking.authenticationFailed = false;

    var payload = {
      dontNavigateToNextAvailableTime: true, // Don't trigger navigation to the next available time because it causes the user to be thrown back into the calendar.
    };
    dispatch('getAvailableTimes', payload);

    if (document.getElementById('book-time-dates')) {
      window.setTimeout(() => {
        state.vueInstance.$SmoothScroll(
          document.getElementById('book-time-dates'),
          500
        );
      }, 100);
    }
  },
  shouldDeselectTimeslot({ state, getters }) {
    if (getters.loading.times) {
      return;
    }

    /* If an activity is not selected, also deselect time slot. This is done to prevent a mobile user from seeing a time slot as selected when no activity is selected */
    if (state.activities.selected == false) {
      state.selectedSlot = false;
    }
  },
  setBankIDLocation({ state }, location) {
    state.ui.signingBankIDOnOtherDevice = false;
    state.ui.signingBankIDOnSameDevice = false;
    if (location) {
      if (location == 'sameDevice') {
        state.bankIDLocation = 'sameDevice';
        state.ui.signingBankIDOnSameDevice = true;
      }
      if (location == 'otherDevice') {
        state.bankIDLocation = 'otherDevice';
        state.ui.signingBankIDOnOtherDevice = true;
      }
    }
  },

  /* Trigger a BankID sign based booking. */
  startBankIDBooking({ state, dispatch, getters }, bankIDLocation) {
    if (!getters.formIsValid) {
      return;
    }
    dispatch('setBankIDLocation', bankIDLocation);
    dispatch('testAddBooking', bankIDLocation);
  },

  /* Test if we can add the booking. This is run before we actually send the booking to the backend and trigger the BankID sign */
  testAddBooking({ state, dispatch, getters }) {
    if (!getters.formIsValid) {
      return;
    }

    state.booking.message = false;
    var timeStart =
      state.selectedSlot.date + ' ' + state.selectedSlot.time + ':00';
    /* Adjust the treatment length manually if needed */
    var duration = getters.getTreatmentLength;
    var timeEnd = moment(
      state.selectedSlot.date + ' ' + state.selectedSlot.time
    )
      .add(duration, 'minutes')
      .format('YYYY-MM-DD HH:mm:ss');
    timeStart = timeStart.toString();

    state.ui.loading.doingBooking = true;

    if (state.booking.authenticationFailed) {
      state.ui.loading.doingBooking = false;
    }

    var bookingData = {
      firstName: getters.toTitleCase(state.patient.firstName),
      lastName: getters.toTitleCase(state.patient.lastName),
      ssn: state.patient.ssn,
      email: state.patient.email.toLowerCase(),
      phone: state.patient.phone,
      terapeutId: state.selectedSlot.terapeut_id,
      activityId: state.activities.selected.activity_id,
      bookingColor: state.activities.selected.activity_standard_color,
      timeStart: timeStart,
      timeEnd: timeEnd,
      newsletterSignup: state.patient.newsletterSignup,
    };

    console.log('BOOKING DATA', bookingData);

    /* Add the room ID and location ID if those parameters exist on the slot */
    if (state.selectedSlot.room_id != undefined) {
      bookingData.roomId = state.selectedSlot.room_id;
    }

    if (state.selectedSlot.location_id != undefined) {
      bookingData.locationId = state.selectedSlot.location_id;
    }

    axios
      .post('/wp-json/nk/cb/testAddBooking/', bookingData)
      .then((response) => {
        if (response.data.data.error == true) {
          console.log('GOT ERROR?R?R?R?R?')
          state.ui.loading.doingBooking = false;
          state.booking.message = response.data.data.message;
          /* If we received an error, clear all the stored available times */
          state.loadedTimes = [];
          dispatch('setBankIDLocation', false);
          return;
        }
        if (response.data.data.success) {
          //dispatch('sendBooking');
          if (state.booking.authenticationFailed) {
            console.log('bookingDatabookingDatabookingData', bookingData);
            axios
              .post('/wp-json/nk/cb/addBooking/', bookingData)
              .then((response) => {
                if (response.data.data.error == true) {
                  state.ui.loading.doingBooking = false;
                  state.booking.message = response.data.data.message;
                  /* If we received an error, clear all the stored available times */
                  state.loadedTimes = [];
                  // dispatch('setBankIDLocation', false);
                  return;
                } else {
                  let bookingDetails = null;
                  if (response) {
                    if (response.data) {
                      if (response.data.data) {
                        if (response.data.data.selectedActivity) {
                          state.activities.selected = response.data.data.selectedActivity;
                        }
                        if (response.data.data.selectedSlot) {
                          state.selectedSlot = response.data.data.selectedSlot;
                        }
                        // Capture booking details if available (similar to old booking module)
                        if (
                          response.data.data.data &&
                          response.data.data.data.rows &&
                          response.data.data.data.rows.row
                        ) {
                          bookingDetails = response.data.data.data.rows.row;
                        }
                      }
                    }
                  }

                  /* Clear any potential error messages that might linger. */
                  state.booking.message = false;

                  /* Clear all state containing information of where the user is doing a BankID sign. */
                  dispatch('setBankIDLocation', false);

                  state.ui.loading.doingBooking = false;
                  state.booking.completed = true;
                  state.ui.showConfirmationModal = true;

                  state.vueInstance.$SmoothScroll(
                    document.getElementById('book-time-form-anchor'),
                    500
                  );
                  state.booking.activityName = state.activities.selected.activity_name;

                  /* Push to Google Tag Manager and Facebook */
                  //dataLayer.push({'event': 'gtm4wp.cbBookingMade'});
                  //

                  // Extract consultation price from infoBox
                  const consultationPrice = (() => {
                    if (!state.infoBox) {
                      return 200; // Default price if no infoBox
                    }

                    // Strip HTML tags first, then try patterns
                    const cleanText = state.infoBox.replace(/<[^>]*>/g, '');
                    console.log('📋 Cleaned infoBox:', cleanText);

                    // Try multiple regex patterns to be more robust
                    const patterns = [
                      /Konsultationsavgift:\s*(\d+)\s*kr/i, // Standard pattern
                      /Konsultationsavgift\s*:\s*(\d+)\s*kr/i, // Extra whitespace around colon
                      /Konsultationsavgift[:\s]*(\d+)\s*kr/i, // Flexible colon/space
                      /(\d+)\s*kr/gi, // Just find any number followed by kr
                    ];

                    for (let pattern of patterns) {
                      const priceMatch = cleanText.match(pattern);
                      if (priceMatch && priceMatch[1]) {
                        return parseInt(priceMatch[1], 10);
                      }
                    }

                    return 200; // Default price if no match found
                  })();

                  console.log('🎯 Booking completed! Sending to GTM dataLayer...', {
                    consultationPrice,
                    activityName: state.booking.activityName,
                    activityId: state.activities.selected.activity_id,
                    terapeutId: state.selectedSlot.terapeut_id,
                    bookingDetails: bookingDetails,
                  });

                  // Prepare booking data for dataLayer
                  const dataLayerPayload = {
                    event: 'booking_completed',
                    event_category: 'Booking',
                    event_label: state.booking.activityName,
                    consultation_price: consultationPrice,
                    currency: 'SEK',
                    activity_id: state.activities.selected.activity_id,
                    terapeut_id: state.selectedSlot.terapeut_id,
                    // Additional parameters for enhanced tracking
                    value: consultationPrice,
                    treatment_name: state.booking.activityName,
                    // Facebook parameters for server-side GTM
                    fb_event_name: 'Lead',
                    fb_custom_event_name: 'TreatmentBooking',
                    fb_custom_parameters: {
                      treatment_name: state.booking.activityName,
                      consultation_price: consultationPrice,
                      currency: 'SEK',
                    },
                    // Delta Projects parameters
                    delta_projects_action: 'order',
                    delta_projects_total_price: consultationPrice,
                    delta_projects_currency: 'SEK',
                    delta_projects_page_id: '$booking' + state.booking.activityName,
                    from_actions: true,
                  };

                  // Add booking details if available
                  if (bookingDetails) {
                    if (bookingDetails.booking_id) {
                      dataLayerPayload.booking_id = bookingDetails.booking_id;
                    }
                    if (bookingDetails.booking_activity_id) {
                      dataLayerPayload.booking_activity_id =
                        bookingDetails.booking_activity_id;
                    }
                    if (bookingDetails.booking_time_start) {
                      dataLayerPayload.booking_time_start =
                        bookingDetails.booking_time_start;
                    }
                    if (bookingDetails.booking_time_end) {
                      dataLayerPayload.booking_time_end = bookingDetails.booking_time_end;
                    }
                    // Add any other booking details that might be present
                    if (bookingDetails.booking_reference) {
                      dataLayerPayload.booking_reference =
                        bookingDetails.booking_reference;
                    }
                  }

                  // Push to dataLayer for GTM (client-side and server-side)
                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push(dataLayerPayload);

                  /* Track that the booking is completed through our custom endpoint that communicates with the Facebook Conversion API */
                  dispatch('trackBookingComplete');

                  state.booking.autostartToken = false;
                  state.booking.orderRef = false;
                }
              })
              .catch((error) => {
                state.ui.loading.doingBooking = false;
                state.booking.message = 'Något gick fel. Försök igen.';
                state.booking.authenticationFailed = true;
                state.booking.backupOrderRef = false;
                /* Clear all state containing information of where the user is doing a BankID sign. */
                dispatch('setBankIDLocation', false);
              });
          } else {
            dispatch('initiateBankIDAuth');
          }
        }
      })
      .catch((error) => {
        state.ui.loading.doingBooking = false;
        state.booking.message = 'Något gick fel. Försök igen.';
        state.booking.authenticationFailed = true;
        /* Clear all state containing information of where the user is doing a BankID sign. */
        dispatch('setBankIDLocation', false);
      });
  },
  cancelBankIDOrder({ state, dispatch, getters }) {
    axios
      .get(
        '/wp-json/nk/cb/cancelBankIDOrder/?orderRef=' + state.booking.orderRef
      )
      .then((response) => {
        console.log('RESPONSE!!!', response, state);
        if (response.data.data.success) {
          clearTimeout(state.collectBankIDResponseTimeout);
          state.ui.loading.doingBooking = false;
          state.booking.message = response.data.data.message;
          state.booking.autostartToken = false;
          state.booking.authenticationFailed = true;
          state.booking.backupOrderRef = state.booking.orderRef;
          state.booking.orderRef = false;
          console.log('RESPONSE AFTER!!!', response, state);
          dispatch('setBankIDLocation', false);
        }
        if (response.data.data.error) {
          state.booking.message = response.data.data.message;
        }
      })
      .catch((error) => {
        state.booking.message =
          'Något gick fel när din bokning skulle avbrytas.';
        state.booking.authenticationFailed = true;
      });
  },
  collectBankID({ state, dispatch, getters }) {
    axios
      .get('/wp-json/nk/cb/collectBankID/?orderRef=' + state.booking.orderRef)
      .then((response) => {
        if (
          response.data.data &&
          response.data.data.status === 'pending' &&
          response.data.data.hint === 'userSign'
        ) {
          clearTimeout(state.qrTimeout);
          state.booking.qrCode = '';
          state.booking.waitingForSign = true;
          state.booking.nbrRuns = 0;
          // state.ui.loading.doingBooking = false;
          // state.booking.message = response.data.data.message;
          // state.booking.autostartToken = false;
          // state.booking.orderRef = false;
          state.collectBankIDResponseTimeout = setTimeout(() => {
            dispatch('collectBankID');
          }, 1000);

          // Stop authenticate call
          // Hide QR
          // Show new div with info about authenticate
          // SHow timer?
          // Add button for restart
        }
        if (response.data.data && response.data.data.status === 'failed') {
          clearTimeout(state.collectBankIDResponseTimeout);
          clearTimeout(state.qrTimeout);
          state.ui.loading.doingBooking = false;
          state.booking.message = response.data.data.message;
          state.booking.autostartToken = false;
          state.booking.orderRef = false;
          state.booking.nbrOfRuns = 0;
          state.booking.waitingForSign = false;
          state.booking.authenticationFailed = true;
        }
        if (response.data.success && response.data.status !== 'pending') {
          if (response.data.data && response.data.data.error) {
            return;
          }
          if (response.data.data && response.data.data.status === 'pending') {
            return;
          }
          clearTimeout(state.collectBankIDResponseTimeout);
          state.ui.loading.doingBooking = false;
          state.booking.message = response.data.message;
          state.booking.authenticationFailed = true;
          state.booking.waitingForSign = false;
          state.booking.qrCode = '';
          state.booking.autostartToken = false;
          state.booking.orderRef = false;
          state.booking.nbrOfRuns = 0;
          state.booking.waitingForSign = false;

          // Add this right after the existing response.data.data checks and before the console.log
          let bookingDetails = null;
          if (response) {
            if (response.data) {
              if (response.data.data) {
                if (response.data.data.selectedActivity) {
                  state.activities.selected =
                    response.data.data.selectedActivity;
                }
                if (response.data.data.selectedSlot) {
                  state.selectedSlot = response.data.data.selectedSlot;
                }
                // Capture booking details if available (similar to old booking module)
                if (
                  response.data.data.data &&
                  response.data.data.data.rows &&
                  response.data.data.data.rows.row
                ) {
                  bookingDetails = response.data.data.data.rows.row;
                }
              }
            }
          }

          /* Clear any potential error messages that might linger. */
          state.booking.message = false;

          /* Clear all state containing information of where the user is doing a BankID sign. */
          dispatch('setBankIDLocation', false);

          state.ui.loading.doingBooking = false;
          state.booking.completed = true;
          state.ui.showConfirmationModal = true;

          state.vueInstance.$SmoothScroll(
            document.getElementById('book-time-form-anchor'),
            500
          );
          state.booking.activityName = state.activities.selected.activity_name;

          /* Push to Google Tag Manager and Facebook */
          //dataLayer.push({'event': 'gtm4wp.cbBookingMade'});
          //

          // Extract consultation price from infoBox
          // Extract consultation price from infoBox (with error handling)
          let consultationPrice = 200; // Default
          try {
            if (state.infoBox) {
              const cleanText = state.infoBox.replace(/<[^>]*>/g, '');
              console.log('📋 Cleaned infoBox:', cleanText);

              const patterns = [
                /Konsultationsavgift:\s*(\d+)\s*kr/i,
                /Konsultationsavgift\s*:\s*(\d+)\s*kr/i,
                /Konsultationsavgift[:\s]*(\d+)\s*kr/i,
                /(\d+)\s*kr/gi,
              ];

              for (let pattern of patterns) {
                const priceMatch = cleanText.match(pattern);
                if (priceMatch && priceMatch[1]) {
                  consultationPrice = parseInt(priceMatch[1], 10);
                  console.log(
                    '💰 Price extracted:',
                    consultationPrice,
                    'using pattern:',
                    pattern
                  );
                  break;
                }
              }
            }
          } catch (error) {
            console.log('Error extracting consultation price:', error);
          }

          // Send tracking data (with error handling)
          try {
            console.log('🎯 Booking completed! Sending to GTM dataLayer...', {
              consultationPrice,
              activityName: state.booking.activityName,
              activityId: state.activities.selected?.activity_id,
              terapeutId: state.selectedSlot?.terapeut_id,
              bookingDetails: bookingDetails,
            });

            const dataLayerPayload = {
              event: 'booking_completed',
              event_category: 'Booking',
              event_label: state.booking.activityName || 'Unknown',
              consultation_price: consultationPrice,
              currency: 'SEK',
              activity_id: state.activities.selected?.activity_id || 'unknown',
              terapeut_id: state.selectedSlot?.terapeut_id || 'unknown',
              value: consultationPrice,
              treatment_name: state.booking.activityName || 'Unknown',
              fb_event_name: 'Lead',
              fb_custom_event_name: 'TreatmentBooking',
              fb_custom_parameters: {
                treatment_name: state.booking.activityName || 'Unknown',
                consultation_price: consultationPrice,
                currency: 'SEK',
              },
              delta_projects_action: 'order',
              delta_projects_total_price: consultationPrice,
              delta_projects_currency: 'SEK',
              delta_projects_page_id:
                '$booking' + (state.booking.activityName || 'Unknown'),
              from_actions: true,
            };

            // Add booking details if available
            if (bookingDetails) {
              if (bookingDetails.booking_id)
                dataLayerPayload.booking_id = bookingDetails.booking_id;
              if (bookingDetails.booking_activity_id)
                dataLayerPayload.booking_activity_id =
                  bookingDetails.booking_activity_id;
              if (bookingDetails.booking_time_start)
                dataLayerPayload.booking_time_start =
                  bookingDetails.booking_time_start;
              if (bookingDetails.booking_time_end)
                dataLayerPayload.booking_time_end =
                  bookingDetails.booking_time_end;
              if (bookingDetails.booking_reference)
                dataLayerPayload.booking_reference =
                  bookingDetails.booking_reference;
            }

            // Push to dataLayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(dataLayerPayload);

            console.log('🎯 Booking tracking sent successfully');
          } catch (error) {
            console.log(
              '⚠️ Error sending booking tracking (but booking still succeeded):',
              error
            );
          }

          /* Track that the booking is completed through our custom endpoint that communicates with the Facebook Conversion API */
          try {
            dispatch('trackBookingComplete');
          } catch (error) {
            console.log('Error in trackBookingComplete:', error);
          }

          state.booking.autostartToken = false;
          state.booking.orderRef = false;
          // state.ui.loading.doingBooking = true;
          // dispatch("setBankIDLocation", false);
        }
        if (response.data.data && response.data.data.error) {
          state.booking.message = response.data.data.message;
          state.booking.nbrOfRuns = 0;
          state.booking.waitingForSign = false;
        }
      })
      .catch((error) => {
        console.log('ERROR?', error);
        state.booking.message = 'Något gick fel när din bokning skulle skapas.';
        state.booking.authenticationFailed = true;
      });
  },
  addQueryParameter({ state }, payload) {
    return new Promise((resolve, reject) => {
      const url = new URL(window.location.href);
      url.searchParams.set(payload.key, payload.value);
      window.history.pushState({}, '', url.toString());
      resolve();
    });
  },
  authenticate({ state, dispatch, getters }) {
    var timeStart =
      state.selectedSlot.date + ' ' + state.selectedSlot.time + ':00';
    /* Adjust the treatment length manually if needed */
    var duration = getters.getTreatmentLength;
    var timeEnd = moment(
      state.selectedSlot.date + ' ' + state.selectedSlot.time
    )
      .add(duration, 'minutes')
      .format('YYYY-MM-DD HH:mm:ss');
    timeStart = timeStart.toString();

    var bookingData = {
      firstName: getters.toTitleCase(state.patient.firstName),
      lastName: getters.toTitleCase(state.patient.lastName),
      ssn: state.patient.ssn,
      email: state.patient.email.toLowerCase(),
      phone: state.patient.phone,
      terapeutId: state.selectedSlot.terapeut_id,
      activityId: state.activities.selected.activity_id,
      bookingColor: state.activities.selected.activity_standard_color,
      timeStart: timeStart,
      timeEnd: timeEnd,
      newsletterSignup: state.patient.newsletterSignup,
      selectedActivity: state.activities.selected,
      selectedSlot: state.selectedSlot,
    };

    /* Add the room ID and location ID if those parameters exist on the slot */
    if (state.selectedSlot.room_id != undefined) {
      bookingData.roomId = state.selectedSlot.room_id;
    }

    if (state.selectedSlot.location_id != undefined) {
      bookingData.locationId = state.selectedSlot.location_id;
    }

    if (state.booking.nbrRuns >= 25) {
      state.booking.nbrRuns = 0;
    }

    axios
      .post('/wp-json/nk/cb/authenticate/', {
        nbrOfRuns: state.booking.nbrRuns,
        bookingData: bookingData,
      })
      .then((response) => {
        state.booking.nbrRuns = state.booking.nbrRuns + 1;
        if (response.data.data.error == true) {
          state.ui.loading.doingBooking = false;
          state.booking.message = response.data.data.message;
          state.booking.authenticationFailed = true;
          dispatch('setBankIDLocation', false);
          return;
        }
        if (response.data.data.success) {
          state.booking.qrCode =
            'https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=' +
            response.data.data.qrString;
          state.booking.orderRef = response.data.data.orderRef;
          state.booking.backupOrderRef = response.data.data.orderRef;
          state.qrTimeout = setTimeout(() => {
            if (!state.waitingForSign) {
              dispatch('authenticate');
            }
          }, 1000);
          dispatch('collectBankID');

          // dispatch('maybeLoadBookingFromOrderRef');
          // state.booking.autostartToken = response.data.data.autostartToken;

          // dispatch('collectBankIDResponseAndSendBooking');
          // /* If we're on the same device, try to trigger the BankID app */
          // if (getters.isSigningBankIDOnSameDevice) {
          // 	/* Set the orderref query parameter, so that if the user is redirected to a new browser tab, new browser window or new browser entirely after their BankID signing, we can fetch the booking from the orderref and finish it, since the URL they are redirected to will now contain the query parameter with an orderref. */
          // 	var queryParams = {
          // 		key: 'orderref',
          // 		value: state.booking.orderRef,
          // 	};
          // 	dispatch('addQueryParameter', queryParams)
          // 		.then(() => {
          // 			dispatch('autostartBankIDApp');
          // 		})
          // 		.catch(() => { });
          // }
        }
      })
      .catch((error) => {
        console.log('ERROR', error);
        state.ui.loading.doingBooking = false;
        state.booking.message = 'Något gick fel. Försök igen.';
        state.booking.authenticationFailed = true;
        /* Clear all state containing information of where the user is doing a BankID sign. */
        dispatch('setBankIDLocation', false);
      });
  },
  initiateBankIDAuth({ state, dispatch, getters }) {
    state.booking.autostartToken = false;
    state.booking.orderRef = false;
    state.orderRefQueryParameterLoaded = false;

    /* Set up the booking data */
    var timeStart =
      state.selectedSlot.date + ' ' + state.selectedSlot.time + ':00';
    /* Adjust the treatment length manually if needed */
    var duration = getters.getTreatmentLength;
    var timeEnd = moment(
      state.selectedSlot.date + ' ' + state.selectedSlot.time
    )
      .add(duration, 'minutes')
      .format('YYYY-MM-DD HH:mm:ss');
    timeStart = timeStart.toString();

    state.ui.loading.doingBooking = true;

    var bookingData = {
      firstName: getters.toTitleCase(state.patient.firstName),
      lastName: getters.toTitleCase(state.patient.lastName),
      ssn: state.patient.ssn,
      email: state.patient.email.toLowerCase(),
      phone: state.patient.phone,
      terapeutId: state.selectedSlot.terapeut_id,
      activityId: state.activities.selected.activity_id,
      bookingColor: state.activities.selected.activity_standard_color,
      timeStart: timeStart,
      timeEnd: timeEnd,
      newsletterSignup: state.patient.newsletterSignup,
      selectedActivity: state.activities.selected,
      selectedSlot: state.selectedSlot,
    };

    /* Add the room ID and location ID if those parameters exist on the slot */
    if (state.selectedSlot.room_id != undefined) {
      bookingData.roomId = state.selectedSlot.room_id;
    }

    if (state.selectedSlot.location_id != undefined) {
      bookingData.locationId = state.selectedSlot.location_id;
    }

    axios
      .post('/wp-json/nk/cb/initiateBankIDAuth/', {
        ssn: state.patient.ssn,
        sameDevice: true,
        bookingData: bookingData,
      })
      .then((response) => {
        if (response.data.data.error == true) {
          state.ui.loading.doingBooking = false;
          state.booking.message = response.data.data.message;
          state.booking.authenticationFailed = true;
          dispatch('setBankIDLocation', false);
          return;
        }
        if (response.data.data.success) {
          state.booking.autostartToken = response.data.data.autostartToken;
          state.booking.orderRef = response.data.data.orderRef;

          dispatch('collectBankIDResponseAndSendBooking');
          /* If we're on the same device, try to trigger the BankID app */
          /* Set the orderref query parameter, so that if the user is redirected to a new browser tab, new browser window or new browser entirely after their BankID signing, we can fetch the booking from the orderref and finish it, since the URL they are redirected to will now contain the query parameter with an orderref. */
          var queryParams = {
            key: 'orderref',
            value: state.booking.orderRef,
          };
          dispatch('addQueryParameter', queryParams)
            .then(() => {
              dispatch('autostartBankIDApp');
            })
            .catch(() => { });
        }
      })
      .catch((error) => {
        state.ui.loading.doingBooking = false;
        state.booking.message = 'Något gick fel. Försök igen.';
        state.booking.authenticationFailed = true;
        /* Clear all state containing information of where the user is doing a BankID sign. */
        dispatch('setBankIDLocation', false);
      });
  },
  /* Poll for a BankID auth result. Also POST all the booking data here, so that we can make the booking if we collect a completed auth. */
  collectBankIDResponseAndSendBooking({ state, dispatch, getters }) {
    state.ui.loading.doingBooking = true;

    var data = {
      orderRef: state.booking.orderRef,
    };

    axios
      .post('/wp-json/nk/cb/collectBankIDResponseAndSendBooking/', data)
      .then((response) => {
        state.booking.message = false;
        if (response.data.data.error == true) {
          state.ui.loading.doingBooking = false;
          state.booking.message = response.data.data.message;
          state.booking.authenticationFailed = true;
          /* If we received an error, clear all the stored available times */
          state.loadedTimes = [];
          /* Clear all state containing information of where the user is doing a BankID sign. */
          dispatch('setBankIDLocation', false);
          state.booking.autostartToken = false;
          state.booking.orderRef = false;
          // state.booking.authenticationFailed = false;
          return;
        }

        /* If the status is pending, try again in two seconds */
        if (response.data.data.status == 'pending') {
          state.collectBankIDResponseTimeout = setTimeout(() => {
            dispatch('collectBankIDResponseAndSendBooking');
          }, 2000);
          return;
        }

        /* If we made it this far, the booking is a success. Clear the timeout to collect a new response */
        clearTimeout(state.collectBankIDResponseTimeout);

        /* 
                If we received parameters about the selected slot and selected activity from our request, add them to the current state. 
                This is used to display proper confirmation messages for bookings that are triggered using a query parameter, e.g. 
                when the BankID app redirects the user to a new browser tab or new browser after authenticating with BankID. This allows us to display 
                the name of the activity, the date and time of the selected slot etc in the booking confirmation modal.
                */
        let bookingDetails = null;
        if (response) {
          if (response.data) {
            if (response.data.data) {
              if (response.data.data.selectedActivity) {
                state.activities.selected = response.data.data.selectedActivity;
              }
              if (response.data.data.selectedSlot) {
                state.selectedSlot = response.data.data.selectedSlot;
              }
              // Capture booking details if available (similar to old booking module)
              if (
                response.data.data.data &&
                response.data.data.data.rows &&
                response.data.data.data.rows.row
              ) {
                bookingDetails = response.data.data.data.rows.row;
              }
            }
          }
        }

        /* Clear any potential error messages that might linger. */
        state.booking.message = false;

        /* Clear all state containing information of where the user is doing a BankID sign. */
        dispatch('setBankIDLocation', false);

        state.ui.loading.doingBooking = false;
        state.booking.completed = true;
        state.ui.showConfirmationModal = true;

        state.vueInstance.$SmoothScroll(
          document.getElementById('book-time-form-anchor'),
          500
        );
        state.booking.activityName = state.activities.selected.activity_name;

        /* Push to Google Tag Manager and Facebook */
        //dataLayer.push({'event': 'gtm4wp.cbBookingMade'});
        //

        // Extract consultation price from infoBox
        const consultationPrice = (() => {
          if (!state.infoBox) {
            return 200; // Default price if no infoBox
          }

          // Strip HTML tags first, then try patterns
          const cleanText = state.infoBox.replace(/<[^>]*>/g, '');
          console.log('📋 Cleaned infoBox:', cleanText);

          // Try multiple regex patterns to be more robust
          const patterns = [
            /Konsultationsavgift:\s*(\d+)\s*kr/i, // Standard pattern
            /Konsultationsavgift\s*:\s*(\d+)\s*kr/i, // Extra whitespace around colon
            /Konsultationsavgift[:\s]*(\d+)\s*kr/i, // Flexible colon/space
            /(\d+)\s*kr/gi, // Just find any number followed by kr
          ];

          for (let pattern of patterns) {
            const priceMatch = cleanText.match(pattern);
            if (priceMatch && priceMatch[1]) {
              return parseInt(priceMatch[1], 10);
            }
          }

          return 200; // Default price if no match found
        })();

        console.log('🎯 Booking completed! Sending to GTM dataLayer...', {
          consultationPrice,
          activityName: state.booking.activityName,
          activityId: state.activities.selected.activity_id,
          terapeutId: state.selectedSlot.terapeut_id,
          bookingDetails: bookingDetails,
        });

        // Prepare booking data for dataLayer
        const dataLayerPayload = {
          event: 'booking_completed',
          event_category: 'Booking',
          event_label: state.booking.activityName,
          consultation_price: consultationPrice,
          currency: 'SEK',
          activity_id: state.activities.selected.activity_id,
          terapeut_id: state.selectedSlot.terapeut_id,
          // Additional parameters for enhanced tracking
          value: consultationPrice,
          treatment_name: state.booking.activityName,
          // Facebook parameters for server-side GTM
          fb_event_name: 'Lead',
          fb_custom_event_name: 'TreatmentBooking',
          fb_custom_parameters: {
            treatment_name: state.booking.activityName,
            consultation_price: consultationPrice,
            currency: 'SEK',
          },
          // Delta Projects parameters
          delta_projects_action: 'order',
          delta_projects_total_price: consultationPrice,
          delta_projects_currency: 'SEK',
          delta_projects_page_id: '$booking' + state.booking.activityName,
          from_actions: true,
        };

        // Add booking details if available
        if (bookingDetails) {
          if (bookingDetails.booking_id) {
            dataLayerPayload.booking_id = bookingDetails.booking_id;
          }
          if (bookingDetails.booking_activity_id) {
            dataLayerPayload.booking_activity_id =
              bookingDetails.booking_activity_id;
          }
          if (bookingDetails.booking_time_start) {
            dataLayerPayload.booking_time_start =
              bookingDetails.booking_time_start;
          }
          if (bookingDetails.booking_time_end) {
            dataLayerPayload.booking_time_end = bookingDetails.booking_time_end;
          }
          // Add any other booking details that might be present
          if (bookingDetails.booking_reference) {
            dataLayerPayload.booking_reference =
              bookingDetails.booking_reference;
          }
        }

        // Push to dataLayer for GTM (client-side and server-side)
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataLayerPayload);

        /* Track that the booking is completed through our custom endpoint that communicates with the Facebook Conversion API */
        dispatch('trackBookingComplete');

        state.booking.autostartToken = false;
        state.booking.orderRef = false;
        // state.booking.authenticationFailed = false;
      })
      .catch((error) => {
        console.log('!ERROR!', error);
        state.ui.loading.doingBooking = false;
        state.booking.message =
          'Något gick fel när bokningen skulle slutföras. Du kan försöka igen.';

        state.booking.autostartToken = false;
        state.booking.backupOrderRef = false;
        state.booking.authenticationFailed = true;
        state.booking.orderRef = false;
        /* Clear all state containing information of where the user is doing a BankID sign. */
        dispatch('setBankIDLocation', false);
      });
  },
  autostartBankIDApp({ state, dispatch, getters }) {
    /* Autostart the BankID app. This is used after receiving a token */
    var autoStartUrl = getters.getAutostartUrl;
    if (autoStartUrl) {
      window.location.href = autoStartUrl;
    }
  },

  initiateCheckout({ state, dispatch }) {
    /* Track the FB event InitiateCheckout when a user starts to enter their details in the checkout form */
    if (state.initiatedCheckout) {
      return;
    }
    dispatch('trackInitiateCheckout');

    fbq('trackCustom', 'InitiateCheckout', {
      treatment_name: state.activities.selected.activity_name,
    });

    state.initiatedCheckout = true;
  },
  toggleSelectingProvider({ state, dispatch }) {
    state.ui.selectingProvider = !state.ui.selectingProvider;
    if (state.ui.selectingProvider == false || state.providers.selected) {
      dispatch('setProvider', false);
    }
  },
  toggleSelectingLocation({ state, dispatch }) {
    state.ui.selectingLocation = !state.ui.selectingLocation;
    if (state.ui.selectingLocation == false || state.locations.selected) {
      dispatch('setLocation', false);
    }
  },
  calendarViewType({ state, dispatch }, type) {
    state.ui.calendarViewType = type;
    let date = state.dates.active.date
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD');

    /* If the date is in the past, set the date to today */
    if (
      state.dates.active.date
        .clone()
        .startOf('month')
        .isBefore(moment().format('YYYY-MM-DD'))
    ) {
      date = moment().format('YYYY-MM-DD');
    }
    dispatch('setupActiveDateFromDate', {
      date: date,
    }).then(() => {
      var payload = {
        dontNavigateToNextAvailableTime: true, // Don't trigger navigation to the next available time because it causes the user to be thrown back into the calendar.
      };
      dispatch('getAvailableTimes', payload);
    });
  },
  handleClickOnMonthCalendarSlot({ state, dispatch }, date) {
    let firstOfWeek = date.date.clone().startOf('week').format('YYYY-MM-DD');
    state.ui.calendarViewType = 'week';
    dispatch('setupActiveDateFromDate', {
      date: firstOfWeek,
    });

    /* Scroll to the correct date in the mobile booking modal */
    window.setTimeout(() => {
      let anchorElement = document.getElementById(
        'booking-calendar-week-mobile-date-anchor-' + date.niceDate
      );
      let modalBody = document.querySelector('.modal-time-slots-body');
      /*
            modalBody.scrollTop = anchorElement.offsetTop;
            */
      state.vueInstance.$SmoothScroll(anchorElement, 500, false, modalBody);
    }, 100);
  },
  /* Store available times for later use */
  storeAvailableTimes({ state }, times) {
    let timeStampInSeconds = Math.floor(Date.now() / 1000);
    let objectToStore = {
      activity_id: state.activities.selected.activity_id,
      date_from: state.dates.active.checkBookingsFromDate,
      date_to: state.dates.active.checkBookingsToDate,
      availableTimes: times,
      exipresAt: timeStampInSeconds + 300, // Set the stored object to be invalid in 300 seconds, i.e. 5 minutes. This is done to not cache times indefinately on the client and to fetch fresh times if needed.
    };
    state.loadedTimes.push(objectToStore);
  },

  /* 
    Function to check if the times for the given treatment and dates are already fetched by the user. 
    If so, use those times instead of reaching out to the ClinicBuddy API 
    */
  availableTimesAreLoaded({ state, dispatch }) {
    let timeStampInSeconds = Math.floor(Date.now() / 1000);
    return new Promise((resolve, reject) => {
      let activity_id = state.activities.selected.activity_id;
      let date_from = state.dates.active.checkBookingsFromDate;
      let date_to = state.dates.active.checkBookingsToDate;
      /* Check if the time is already stored */
      for (let i in state.loadedTimes) {
        let loadedTime = state.loadedTimes[i];

        /* Check if the loaded time has expired. If so, unset it and continue the loop */
        if (loadedTime.exipresAt < timeStampInSeconds) {
          continue;
        }

        if (loadedTime.activity_id == activity_id) {
          /* Check if the loaded time is for the same dates if the requested times are from dates WITHIN dates that we have times stored for */
          if (
            loadedTime.date_from == date_from ||
            moment(loadedTime.date_from).isBefore(date_from)
          ) {
            if (
              loadedTime.date_to == date_to ||
              moment(loadedTime.date_to).isAfter(date_to)
            ) {
              /* The time is stored. Set the available times to the stored times */
              state.availableTimes = loadedTime.availableTimes;
              dispatch('setupAvailableTimes');
              resolve(true);
            }
          }
        }
      }
      reject();
    });
  },
  fakeCompleteBooking({ state, dispatch }) {
    state.ui.loading.doingBooking = false;
    state.booking.completed = true;
    state.ui.showConfirmationModal = true;
  },

  /* Track a completed booking in the Facebook Conversion API through our custom endpoint */
  trackBookingComplete({ state }) {
    var sourceUrl = window.location.href;
    var email = state.patient.email.toLowerCase();
    var phone = state.patient.phone;
    axios
      .get(
        '/wp-json/nk/capi/bookingComplete/?sourceUrl=' +
        sourceUrl +
        '&treatmentName=' +
        state.booking.activityName +
        '&email=' +
        email +
        '&phone=' +
        phone
      )
      .then((response) => { })
      .catch((error) => { });
  },

  /* Track the event InitiateCheckout in the Facebook Conversion API through our custom endpoint */
  trackInitiateCheckout({ state }) {
    var sourceUrl = window.location.href;
    axios
      .get(
        '/wp-json/nk/capi/initiateCheckout/?sourceUrl=' +
        sourceUrl +
        '&treatmentName=' +
        state.activities.selected.activity_name
      )
      .then((response) => { });
  },

  /* 
    Get any custom treatment durations for each treatment and provider from the WordPress backend. 
    When the user makes a booking, we check if the provider has a custom duration for this treatment and 
    sets the end time accordingly.
    */
  getCustomTreatmentDurations({ state }) {
    axios
      .get('/wp-json/nk/cb/getCustomTreatmentDurations/')
      .then((response) => {
        state.customTreatmentDurations = response.data.data;
      });
  },

  async getInfoBox({ state }) {
    try {
      const response = await axios.get('/wp-json/nk/cb/getInfoBox', {
        params: {
          activity_id: state.activities.selected.activity_id,
        },
      });

      // console.log(response.data.data.content); // Ensure the response structure matches your expectations

      state.infoBox = response.data.data.content;
    } catch (error) {
      state.infoBox = null;
      console.error('Error fetching infoBox:', error);
    }
  },
};
